export enum DataSourceApprovalStatus {
  // PLAT-4318 — deliberately NO `Draft` member. The shipped backend adds `DRAFT` to
  // `DataSource.ConnectStatusChoices` only, and the draft action sets `connect_status` alone
  // (api/views.py:284), so `approval_status` never carries the token. A `Draft` member here
  // would be dead, and worse: it would invite a predicate to compare against a value the
  // server cannot produce. The Draft badge on the Discover list comes from `connect_status`.
  New = 'NEW',
  Catalogued = 'CATALOGUED',
  UnderDiscover = 'UNDER_DISCOVER',
  Discovery = 'DISCOVERY',
  ConnectionFailed = 'CONNECTION_FAILED',
  Approved = 'APPROVED',
  PendingApproval = 'PENDING_APPROVAL',
}
